export const AUTHOR = 1
export const ADMIN = 2
export const Label = {
  [AUTHOR]: 'roleForm.type.author',
  [ADMIN]: 'roleForm.type.admin',
}

export const RoleTypes = [AUTHOR, ADMIN]
